export function filterGroupsForCurrentUser(groups = [], currentUser = {}) {
    const roleName = String(currentUser?.userRole?.name || "").toLowerCase();
    if (!currentUser?.username || roleName === "admin") {
        return groups || [];
    }

    const allowedGroupIds = (currentUser.groups || [])
        .map(group => String(group.id || group.pk))
        .filter(Boolean);

    if (!allowedGroupIds.length) {
        return [];
    }

    return (groups || []).filter(group =>
        allowedGroupIds.includes(String(group.id || group.pk || group.value))
    );
}

export function getAllowedGroupIdsForCurrentUser(currentUser = {}) {
    const roleName = String(currentUser?.userRole?.name || "").toLowerCase();
    if (!currentUser?.username || roleName === "admin") {
        return null;
    }

    return (currentUser.groups || [])
        .map(group => String(group.id || group.pk))
        .filter(Boolean);
}

export function filterRecordsByGroupsForCurrentUser(records = [], currentUser = {}) {
    const allowedGroupIds = getAllowedGroupIdsForCurrentUser(currentUser);
    if (allowedGroupIds === null) {
        return records || [];
    }

    if (!allowedGroupIds.length) {
        return [];
    }

    return (records || []).filter(record =>
        (record.groups || []).some(group =>
            allowedGroupIds.includes(String(group.id || group.pk))
        )
    );
}
